<template>
  <div
    v-if="!loading"
    style="padding: 0; margin: auto; border-radius: 5px; background: white"
  >
    <v-card
      tile
      flat
      style="
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 60px;
        background: white;
        z-index: 5;
      "
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
        "
      >
        <v-toolbar-title class="overline">
          <p
            :style="`font-size:${
              wWidth > 780 ? '20px' : '3vw'
            }; margin: 0; padding-left: 5px;`"
          >
            DETAIL REGISTRASI VENDOR
            <v-tooltip bottom color="grey">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  text
                  icon
                  color="grey darken-2"
                  @click="getDetail"
                >
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>refresh page</span>
            </v-tooltip>
          </p>
          <!-- <p
            v-if="form"
            style="
              position: absolute;
              bottom: 15px;
              left: 11px;
              font-weight: bold;
              font-size: 12px;
            "
          >
            {{ form.request_no }}
          </p> -->
        </v-toolbar-title>
      </div>

      <div
        v-if="form != null"
        class="d-flex justify-center align-center"
        :style="`position:absolute; right:0; top:41px; ${statusColor(
          form.status != null ? form.status.id : null
        )} padding: 5px 30px; min-width: 200px; z-index:20;`"
      >
        <p
          style="
            margin: 0;
            font-size: 16px;
            font-weight: bolder;
            text-transform: uppercase;
          "
        >
          {{ form.status != null ? form.status.name : '-' }}
        </p>
      </div>
      <div
        v-if="form != null"
        class="d-flex justify-center align-center"
        style="
          position: absolute;
          left: 0;
          top: 45px;
          padding: 5px 30px;
          width: 1200px;
          background: rgba(255, 255, 255, 0.7);
        "
      >
        <div
          class="d-flex justify-start align-center"
          style="position: absolute; right: 0; left: 0"
        >
          <p style="font-size: 13px; margin: 0 15px; font-weight: bold">
            No. Registrasi : {{ form.request_no }}
          </p>
          ||
          <p style="font-size: 12px; margin: 0 5px">
            Tgl. Buat :
            {{ convertDate(form.createdAt) }}/{{ form.created_by_name }}
          </p>
          ||
          <p style="font-size: 12px; margin: 0 0 0 15px">
            Tgl. Terima :
            {{ convertDate(form.takeAt) }}/{{ form.take_by_name }}
          </p>
        </div>
      </div>
      <div class="d-flex">
        <v-card-actions
          v-if="
            getUserProfile.level.find(
              ({ id }) =>
                id == config.application.all.userLevel.administrator ||
                id == config.application.ecatalogue.userLevel.adminCatalogue
            ) != undefined && form != null
          "
        >
          <div v-if="!isEdit">
            <div v-if="form.status != null && form.status.id == 0">
              <v-btn
                style="font-weight: bold"
                class="mr-1"
                x-small
                text
                outlined
                color="primary"
                @click.prevent="enableEdit"
              >
                <v-icon x-small color="primary" class="icon-position">
                  mdi-pencil
                </v-icon>
                Edit
              </v-btn>
              <v-btn
                class="button-status mr-1"
                x-small
                text
                outlined
                color="success"
                @click="submitDocument"
              >
                SUBMIT
              </v-btn>
              <v-btn
                class="button-status"
                x-small
                text
                outlined
                color="red"
                @click="cancelDocument"
              >
                CANCEL
              </v-btn>
            </div>

            <div
              v-if="
                detailData != null &&
                detailData.status != null &&
                detailData.status.id == 1 &&
                isAllow &&
                detailData.approver_users.find(
                  (e) => e === getUserProfile.employee.email
                ) != undefined
              "
            >
              <v-btn
                class="button-status mr-2"
                x-small
                text
                outlined
                color="success"
                @click="confirmDocument"
              >
                APPROVE
              </v-btn>
              <v-btn
                class="button-status"
                x-small
                text
                outlined
                color="red"
                @click="rejectDocument"
              >
                REJECT
              </v-btn>
            </div>
            <!-- <div v-if="form.status != null && form.status.id == 2">
              <v-btn
                v-if="form.status.id == 2"
                class="button-status mr-2"
                x-small
                text
                outlined
                color="primary"
                @click="takeDocument"
              >
                TAKE
              </v-btn>
              <v-btn
                class="button-status"
                x-small
                text
                outlined
                color="red"
                @click="cancelDocument"
              >
                CANCEL
              </v-btn>
            </div> -->
            <div v-if="form.status != null && form.status.id == 2">
              <v-btn
                class="button-status mr-2"
                x-small
                text
                outlined
                color="success"
                @click="doneDocument"
              >
                TAKE
              </v-btn>
              <v-btn
                class="button-status"
                x-small
                text
                outlined
                color="red"
                @click="cancelDocument"
              >
                CANCEL
              </v-btn>
            </div>
            <div
              v-if="
                form.status != null &&
                (form.status.id == 4 || form.status.id == 5)
              "
            >
              <v-btn
                class="button-status"
                x-small
                text
                outlined
                color="primary"
                @click="setDraftDocument"
              >
                SET DRAFT
              </v-btn>
            </div>
          </div>

          <div v-else>
            <v-btn
              class="font-bold mr-1"
              x-small
              text
              outlined
              color="primary"
              type="button"
              @click="saveEdit"
            >
              <v-icon x-small color="primary" class="icon-position">
                mdi-content-save-edit-outline
              </v-icon>
              Save
            </v-btn>
            <v-btn
              class="button-cancel"
              x-small
              text
              outlined
              color="red"
              @click="enableEdit"
            >
              <v-icon x-small color="red" class="icon-position">
                mdi-cancel
              </v-icon>
              Cancel
            </v-btn>
          </div>
        </v-card-actions>

        <div
          v-if="getVendorRegistList != null && getVendorRegistList != undefined"
          class="d-flex mr-2 mt-2 ml-5"
        >
          <h6
            class="mr-2"
            style="
              text-align: right;
              border: 1px solid rgba(0, 0, 0, 0.3);
              border-radius: 5px;
              cursor: pointer;
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  icon
                  x-small
                  @click="previousPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) === 0 ||
                    $route.query.idx === undefined
                  "
                >
                  <v-icon small style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-left</v-icon
                  >
                </v-btn>
              </template>
              <span>previous</span>
            </v-tooltip>
          </h6>
          <p style="margin: 0; position: relative; top: 1px">
            <span>
              {{
                $route.query.idx !== undefined
                  ? Number($route.query.idx) + 1
                  : '1'
              }}
            </span>
            /
            <span>
              {{
                $route.query.idx !== undefined
                  ? getVendorRegistList.registrationList.length
                  : '1'
              }}
            </span>
          </p>
          <h6
            class="ml-2"
            style="
              text-align: right;
              border: 1px solid rgba(0, 0, 0, 0.3);
              border-radius: 5px;
              cursor: pointer;
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-if="$route.query.idx === undefined"
                  icon
                  x-small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  disabled
                >
                  <v-icon samll style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
                <v-btn
                  v-else
                  icon
                  x-small
                  @click="nextPage"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    Number($route.query.idx) ===
                    getVendorRegistList.registrationList.length - 1
                  "
                >
                  <v-icon samll style="position: relative; top: -1px; right: 0"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </template>
              <span>next</span>
            </v-tooltip>
          </h6>
        </div>
      </div>
    </v-card>
    <div v-if="form != null">
      <v-stepper class="elevation-0" v-model="stepperElement" vertical>
        <v-stepper-step :complete="stepperElement > 1" step="1" editable>
          Informasi Umum Vendor
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-form
            ref="stepOneForm"
            @submit.prevent="nextStep(1)"
            lazy-validation
            :disabled="loading"
            :readonly="!isEdit"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" :no-gutters="!isEdit">
                <!-- <v-col cols="12" md="9" style="padding: 0"></v-col> -->
                <v-col cols="8" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Nama Perusahaan *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.name"
                        :rules="rules.companyNameRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kode Vendor
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field v-if="detailData != null"
                        @keydown.enter.prevent
                        dense
                        :value="detailData.code"
                        disabled
                        :outlined="isEdit"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="8" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Jenis Usaha *
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                    >
                      <v-radio-group
                        @keydown.enter.prevent
                        v-model="form.business_entity"
                        :rules="rules.companyTypeRules"
                        style="
                          width: 100%;
                          height: 45px;
                          position: relative;
                          top: -10px;
                        "
                      >
                        <div
                          class="d-flex justify-content-around align-content-between"
                        >
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="1"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">UD</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="2"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">CV</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="3"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">PT</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="4"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">
                              Lain - lain
                            </p>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Tahun Berdiri
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        type="number"
                        v-model="form.year_founded"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Alamat Kantor *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-textarea
                        @keydown.enter.prevent
                        dense
                        auto-grow
                        rows="1"
                        :outlined="isEdit"
                        v-model="form.address"
                        :rules="rules.addressRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Provinsi *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.province"
                        :items="dropdown.province"
                        :rules="rules.provinceRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        :outlined="isEdit"
                        dense
                        :clearable="isEdit"
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kota *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.city"
                        :items="dropdown.city"
                        :rules="rules.cityRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        :outlined="isEdit"
                        dense
                        :clearable="isEdit"
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kode Pos *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.post_code"
                        :rules="rules.postCodeRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="6" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Lat
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.lat"
                        :rules="rules.latRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="6" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        lng
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.lng"
                        :rules="rules.lngRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        No. Telepon *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        type="number"
                        v-model="form.phone_number"
                        :rules="rules.phoneRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Email *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.email"
                        :rules="rules.emailRules"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Website (jika ada)
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        :outlined="isEdit"
                        v-model="form.website"
                        :rules="rules.websiteRules"
                      />
                    </v-col>
                  </div>
                </v-col>

                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Skala Perusahaan *
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                    >
                      <v-radio-group
                        @keydown.enter.prevent
                        v-model="form.company_scale"
                        :rules="rules.companyScaleRules"
                        style="
                          width: 100%;
                          height: 45px;
                          position: relative;
                          top: -10px;
                        "
                      >
                        <div
                          class="d-flex justify-content-around align-content-between"
                        >
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="1"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Kecil</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="2"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Menengah</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="3"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Besar</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="4"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">
                              Lain - lain
                            </p>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </div>
                </v-col>
                <!--  -->
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Klasifikasi *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.classification"
                        :rules="rules.classificationRules"
                        :items="dropdown.classification"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        :outlined="isEdit"
                        dense
                        :clearable="isEdit"
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Sub-Klasifikasi
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.sub_classification"
                        :items="dropdown.subClassification"
                        :rules="rules.subClassificationRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        :outlined="isEdit"
                        dense
                        :clearable="isEdit"
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <!-- Contact Person -->
                <v-col cols="12" style="padding: 10px">
                  <v-row
                    no-gutters
                    style="
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 5px;
                      padding: 10px;
                    "
                  >
                    <v-col v-if="isEdit" cols="12">
                      <v-row no-gutters>
                        <v-col cols="12" md="12" style="padding: 0">
                          <div style="padding: 0 10px">
                            <v-col cols="12" style="padding: 0">
                              <p
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  font-weight: bold;
                                  color: rgba(0, 0, 0, 0.5);
                                "
                              >
                                Nama Kontak Person *
                              </p>
                            </v-col>
                            <v-col cols="12" style="padding: 0">
                              <v-text-field
                                @keydown.enter.prevent
                                dense
                                :outlined="isEdit"
                                :rules="rules.vendorNameRules"
                                v-model="form.vendor_cp_name"
                              />
                            </v-col>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" style="padding: 0">
                          <div style="padding: 0 10px">
                            <v-col cols="12" style="padding: 0">
                              <p
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  font-weight: bold;
                                  color: rgba(0, 0, 0, 0.5);
                                "
                              >
                                Jabatan Kontak Person
                              </p>
                            </v-col>
                            <v-col cols="12" style="padding: 0">
                              <v-text-field
                                @keydown.enter.prevent
                                dense
                                :outlined="isEdit"
                                v-model="form.vendor_cp_position"
                              />
                            </v-col>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" style="padding: 0">
                          <div style="padding: 0 10px">
                            <v-col cols="12" style="padding: 0">
                              <p
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  font-weight: bold;
                                  color: rgba(0, 0, 0, 0.5);
                                "
                              >
                                Nomor Kontak Person *
                              </p>
                            </v-col>
                            <v-col cols="12" style="padding: 0">
                              <v-text-field
                                @keydown.enter.prevent
                                dense
                                :outlined="isEdit"
                                type="number"
                                :rules="rules.vendorPhoneRules"
                                v-model="form.vendor_cp_phone"
                              />
                            </v-col>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          style="padding: 10px"
                          class="d-flex justify-center align-center"
                        >
                          <v-btn
                            @click="saveContactPerson"
                            style="font-size: 10px; margin-left: auto"
                            elevation="2"
                            tilerounded="5px"
                            small
                            color="primary"
                            class="white--text"
                          >
                            <v-icon small class="mr-2">
                              mdi-content-save
                            </v-icon>
                            <span>Tambahkan</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 10px; margin: 0">
                        <v-col cols="12" style="padding: 0">
                          <v-data-table
                            :headers="vendorContactPersonHeaders"
                            :items="form.contact_person"
                            hide-default-footer
                            class="elevation-1"
                            dense
                          >
                            <template v-slot:[`item.no`]="{ index }">
                              <div style="width: 25px; font-size: 12px">
                                {{ index + 1 }}
                              </div>
                            </template>
                            <template v-slot:[`item.name`]="{ item }">
                              <div
                                style="
                                  width: 210px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  :outlined="isEdit"
                                  :readonly="!isEdit"
                                  v-model="item.name"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.position`]="{ item }">
                              <div
                                style="
                                  width: 120px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  :outlined="isEdit"
                                  :readonly="!isEdit"
                                  v-model="item.position"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.phone`]="{ item }">
                              <div
                                style="
                                  width: 160px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  :outlined="isEdit"
                                  :readonly="!isEdit"
                                  v-model="item.phone"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.action`]="{ index }">
                              <div
                                class="d-flex justify-center align-center"
                                style="width: 50px; height: 60px"
                              >
                                <v-tooltip right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        removeTableItem('contact_person', index)
                                      "
                                      small
                                      color="error"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Delete</span>
                                </v-tooltip>
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 2" step="2" editable>
          Informasi Pembayaran (Finance)
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-form
            ref="stepTwoForm"
            @submit.prevent="nextStep(2)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama PIC *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :rules="rules.financeNameRules"
                            v-model="form.finance.pic_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nomor PIC *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            type="number"
                            :rules="rules.financePhoneRules"
                            v-model="form.finance.pic_phone"
                          />
                        </v-col>
                      </div>
                    </v-col>

                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Atas Nama *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :readonly="!isEdit"
                            :rules="rules.financeAccountNameRules"
                            v-model="form.finance.account_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="8" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Metode Pembayaran *
                          </p>
                        </v-col>
                        <v-col
                          cols="12"
                          style="
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 0;
                          "
                        >
                          <v-radio-group
                            @keydown.enter.prevent
                            :rules="rules.financePaymentMethodRules"
                            v-model="form.finance.payment_method"
                            :readonly="!isEdit"
                            style="
                              width: 100%;
                              height: 30px;
                              position: relative;
                              top: -10px;
                            "
                          >
                            <div
                              class="d-flex justify-content-between align-content-between"
                            >
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="1"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">Cash</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="2"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">TOP 15</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="3"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">TOP 25</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="4"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">TOP 30</p>
                              </div>
                              <div
                                style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                              >
                                <v-radio
                                  :value="5"
                                  style="margin: 0; height: 25px; padding: 0"
                                ></v-radio>
                                <p style="margin: 0; font-size: 12px">TOP 45</p>
                              </div>
                            </div>
                          </v-radio-group>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              elevation="0"
              style="
                border: 1px solid rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                padding: 10px;
              "
            >
              <v-row no-gutters style="padding: 15px">
                <v-col v-if="isEdit" cols="12">
                  <v-row no-gutters>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nomor Rekening *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            type="number"
                            :rules="rules.financeAccountNumberRules"
                            v-model="form.finance.account_number"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Bank *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="form.finance.bank"
                            :items="dropdown.bank"
                            :rules="rules.financeBankRules"
                            style="margin: 0"
                            item-text="name"
                            item-value="code"
                            return-object
                            :outlined="isEdit"
                            dense
                            :clearable="isEdit"
                          ></v-autocomplete>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0"></v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kantor Cabang (KCU)
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :rules="rules.financeKcuRules"
                            v-model="form.finance.kcu"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                      style="padding: 10px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        @click="saveVendorFinance"
                        style="font-size: 10px; margin-right: auto"
                        elevation="2"
                        tilerounded="5px"
                        small
                        color="primary"
                        class="white--text"
                      >
                        <v-icon small class="mr-2"> mdi-content-save </v-icon>
                        <span>Tambahkan</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px; margin-top: 15px">
                    <v-col cols="12" style="padding: 0">
                      <v-data-table
                        :headers="financeHeaders"
                        :items="form.finance.account"
                        hide-default-footer
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="width: 25px; font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                          <div
                            style="width: 210px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.name"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.phone`]="{ item }">
                          <div
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.phone"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.account_number`]="{ item }">
                          <div
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.account_number"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.bank`]="{ item }">
                          <div
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <v-autocomplete
                              @keydown.enter.prevent
                              :items="dropdown.bank"
                              :outlined="isEdit"
                              dense
                              readonly
                              item-text="name"
                              item-value="id"
                              return-object
                              style="margin: 0"
                              v-model="item.bank"
                            ></v-autocomplete>
                          </div>
                        </template>
                        <template v-slot:[`item.kcu`]="{ item }">
                          <div
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.kcu"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.account_name`]="{ item }">
                          <div
                            style="width: 160px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.account_name"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.payment_method`]="{ item }">
                          <div
                            style="width: 120px; height: 45px; font-size: 12px"
                          >
                            <v-autocomplete
                              @keydown.enter.prevent
                              :items="dropdown.paymentMethod"
                              :outlined="isEdit"
                              dense
                              readonly
                              item-text="name"
                              item-value="id"
                              return-object
                              style="margin: 0"
                              v-model="item.payment_method"
                            ></v-autocomplete>
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ index }">
                          <div
                            class="d-flex justify-center align-center"
                            style="width: 50px; height: 60px"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="removeTableItem('finance', index)"
                                  small
                                  color="error"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 3" step="3" editable>
          Kategori Produk/Jasa yang Ditawarkan
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-form
            ref="stepThreeForm"
            @submit.prevent="nextStep(3)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <v-col v-if="isEdit" cols="12">
                  <v-row no-gutters>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Kategori Produk/ Jasa
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            rows="3"
                            auto-grow
                            v-model="form.product_category_description"
                            :rules="rules.productCategoryRules"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="10" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Lampirkan Katalog Disini
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-file-input
                            style="font-size: 11px"
                            ref="uploadDoc"
                            placeholder="Pilih file"
                            dense
                            append-icon="mdi-paperclip"
                            prepend-icon=""
                            clearable
                            outlined
                            @click:clear="clearFileKatalog(undefined)"
                            @change="(event) => uploadKatalog(event)"
                          ></v-file-input>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      style="padding: 10px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        @click="saveProductCategory"
                        style="font-size: 10px; margin-left: auto"
                        elevation="2"
                        tilerounded="5px"
                        small
                        color="primary"
                        class="white--text"
                      >
                        <v-icon small class="mr-2"> mdi-content-save </v-icon>
                        <span>Tambahkan</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px; margin-top: 15px">
                    <v-col cols="12" style="padding: 0">
                      <v-data-table
                        :headers="categoryProductHeaders"
                        :items="form.product_category"
                        hide-default-footer
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                          <div
                            style="
                              font-size: 12px;
                              min-width: 320px;
                              padding-top: 10px;
                            "
                          >
                            <v-textarea
                              @keydown.enter.prevent
                              dense
                              auto-grow
                              :rows="1"
                              :outlined="isEdit"
                              readonly
                              v-model="item.description"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.file`]="{ item }">
                          <div style="font-size: 12px; padding-top: 10px">
                            <v-tooltip bottom color="grey">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  text
                                  icon
                                  color="grey darken-2"
                                  @click="downloadFile(item)"
                                >
                                  <v-icon small>mdi-file-download</v-icon>
                                </v-btn>
                              </template>
                              <span>Lihat file</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ index }">
                          <div
                            class="d-flex justify-center align-center"
                            style="width: 50px; height: 60px"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="
                                    removeTableItem('product_category', index)
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="error"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 4" step="4" editable>
          Pengalaman & Referensi Client
        </v-stepper-step>
        <v-stepper-content step="4">
          <v-form
            ref="stepFourForm"
            @submit.prevent="nextStep(4)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <v-col v-if="isEdit" cols="12">
                  <v-row no-gutters>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama Client
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :rules="rules.clientNameRules"
                            v-model="form.exp_client_name"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            No. Telepon Client
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            v-model="form.exp_client_phone"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Proyek / Produk yang disuplai
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            :outlined="isEdit"
                            :rules="rules.projectDescRules"
                            v-model="form.exp_project_or_product"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Tahun
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            type="number"
                            :outlined="isEdit"
                            :rules="rules.projectYearRules"
                            v-model="form.exp_year"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      style="padding: 10px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        @click="saveExperience"
                        style="font-size: 10px; margin-left: auto"
                        elevation="2"
                        tilerounded="5px"
                        small
                        color="primary"
                        class="white--text"
                      >
                        <v-icon small class="mr-2"> mdi-content-save </v-icon>
                        <span>Tambahkan</span>
                      </v-btn>
                    </v-col>
                  </v-row></v-col
                >
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px; margin-top: 15px">
                    <v-col cols="12" style="padding: 0">
                      <v-data-table
                        :headers="experienceHeaders"
                        :items="form.experience"
                        hide-default-footer
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="width: 25px; font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.client_name`]="{ item }">
                          <div
                            style="width: 210px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.client_name"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.client_phone`]="{ item }">
                          <div
                            style="width: 210px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.client_phone"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.project_or_product`]="{ item }">
                          <div
                            style="width: 310px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              readonly
                              v-model="item.project_or_product"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.year`]="{ item }">
                          <div
                            style="width: 75px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              :outlined="isEdit"
                              type="number"
                              readonly
                              v-model="item.year"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ index }">
                          <div
                            class="d-flex justify-center align-center"
                            style="width: 50px; height: 60px"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="removeTableItem('experience', index)"
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="error"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 5" step="5" editable>
          Kelengkapan Dokumen
          <!-- <small style="margin-top: 5px">(password dapat dilewatkan)</small> -->
        </v-stepper-step>
        <v-stepper-content step="5">
          <v-form
            ref="stepFiveForm"
            @submit.prevent="nextStep(5)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0" class="mb-12">
              <v-row style="padding: 15px" no-gutters>
                <v-col cols="12" style="padding: 0">
                  <v-data-table
                    :headers="documentHeaders"
                    :items="form.vendor_document"
                    hide-default-footer
                    class="elevation-1"
                    dense
                  >
                    <template v-slot:[`item.no`]="{ index }">
                      <div style="width: 35px; font-size: 12px">
                        {{ index + 1 }}
                      </div>
                    </template>
                    <template v-slot:[`item.document_name`]="{ item }">
                      <div style="width: 280px; height: 45px; font-size: 10px">
                        <v-text-field
                          style="font-size: 11px"
                          @keydown.enter.prevent
                          dense
                          readonly
                          :outlined="isEdit"
                          v-model="item.document_name"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.is_have`]="{ item }">
                      <div>
                        <v-checkbox
                          v-model="item.is_have"
                          style="margin: 0; height: 25px; padding: 0"
                          :readonly="!isEdit"
                        ></v-checkbox>
                      </div>
                    </template>
                    <template v-slot:[`item.file`]="{ item, index }">
                      <div
                        v-if="isEdit"
                        style="width: 160px; height: 45px; position: relative"
                      >
                        <v-file-input
                          style="font-size: 11px"
                          ref="uploadDoc"
                          placeholder="Upload File"
                          dense
                          append-icon="mdi-paperclip"
                          prepend-icon=""
                          :clearable="isEdit"
                          @click:clear="clearFileUpload(index)"
                          @change="(event) => uploadFileDoc(index, event)"
                        ></v-file-input>
                        <span
                          style="
                            position: absolute;
                            bottom: 0;
                            font-size: 9px;
                            width: 210px;
                          "
                          >{{ item.file }}</span
                        >
                      </div>
                      <div v-else>
                        <v-tooltip bottom color="grey">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              text
                              icon
                              color="grey darken-2"
                              @click="downloadFile(item)"
                            >
                              <v-icon small>mdi-file-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Lihat file</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div style="width: 160px; height: 45px; font-size: 12px">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          v-model="item.description"
                          :readonly="!isEdit"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item, index }">
                      <div
                        class="d-flex justify-center align-center"
                        style="width: 50px; height: 60px"
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="error"
                              @click="clearDocument(item, index)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 6" step="6" editable>
          Approval Matrix
          <!-- <small style="margin-top: 5px">(password dapat dilewatkan)</small> -->
        </v-stepper-step>
        <v-stepper-content step="6">
          <v-form ref="stepSixForm" lazy-validation :disabled="loading">
            <v-card v-if="detailData != null" elevation="0" class="mb-12">
              <v-row no-gutters>
                <v-col cols="12" style="padding: 0">
                  <v-data-table
                    v-if="detailData.approval_matrix != null"
                    mobile-breakpoint="0"
                    :headers="approvalHeaders"
                    :items="detailData.approval_matrix"
                    :items-per-page="10"
                    class="elevation-1 mx-auto"
                    hide-default-footer
                  >
                    <template v-slot:[`item.document_no`]="{ item }">
                      <div style="width: 140px; font-size: 12px">
                        {{ item.document_no }}
                      </div>
                    </template>
                    <template v-slot:[`item.table_name`]="{ item }">
                      <div style="width: 140px; font-size: 12px">
                        {{ item.table_name }}
                      </div>
                    </template>
                    <template v-slot:[`item.approver_user`]="{ item }">
                      <div style="cursor: pointer" v-if="item">
                        <v-chip
                          label
                          outlined
                          small
                          style="
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                          "
                          v-for="(item, index) in item.approver_user"
                          :key="index"
                        >
                          {{ item.user != null ? item.user.name : '-' }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.approved`]="{ item }">
                      <div
                        v-for="(items, index) in item.approver_user"
                        :key="index"
                        style="width: 140px"
                      >
                        <v-chip
                          v-if="items.status == 1"
                          label
                          outlined
                          small
                          style="
                            position: relative;
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                          "
                        >
                          {{ items.user != null ? items.user.name : '-' }}
                          <v-tooltip bottom color="primary">
                            <template v-slot:activator="{ attrs, on }">
                              <div
                                v-if="items.note"
                                v-bind="attrs"
                                v-on="on"
                                @click="openCommentDialog(items)"
                                style="
                                  position: absolute;
                                  top: 0;
                                  right: 0;
                                  width: 20px;
                                  bottom: 0;
                                  background: white;
                                "
                              >
                                <v-icon small color="info"
                                  >mdi-comment-alert</v-icon
                                >
                              </div>
                            </template>
                            <span>Klik untuk melihat catatan</span>
                          </v-tooltip>
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.rejected`]="{ item }">
                      <div
                        v-for="(items, index) in item.approver_user"
                        :key="index"
                        style="width: 240px"
                      >
                        <v-chip
                          v-if="items.status == -1"
                          label
                          outlined
                          small
                          style="
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                          "
                        >
                          <span>
                            {{ items.user != null ? items.user.name : '-' }}
                          </span>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ attrs, on }">
                              <div
                                v-if="items.note"
                                v-bind="attrs"
                                v-on="on"
                                @click="openCommentDialog(items)"
                                style="
                                  position: absolute;
                                  top: 0;
                                  right: 0;
                                  width: 20px;
                                  bottom: 0;
                                  background: white;
                                "
                              >
                                <v-icon small color="info"
                                  >mdi-comment-alert</v-icon
                                >
                              </div>
                            </template>
                            <span>Klik untuk melihat catatan</span>
                          </v-tooltip>
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.created_at`]="{ item }">
                      <div style="width: 140px; font-size: 12px">
                        {{ item.created_at }}
                      </div>
                    </template>
                    <template v-slot:[`item.updated_at`]="{ item }">
                      <div
                        v-for="(items, index) in item.approver_user"
                        :key="index"
                        style="width: 140px; font-size: 12px"
                      >
                        <span v-if="items.status == 1">
                          {{
                            items.updated_at != null ? items.updated_at : '-'
                          }}
                        </span>
                        <br v-if="index > 0" />
                      </div>
                    </template>
                  </v-data-table>
                  <div
                    v-if="
                      getUserProfile.level.find(({ id }) => id === '41') ===
                      undefined
                    "
                  >
                    <div
                      style="text-align: left; padding-left: 5px"
                      v-if="detailData.status.id == 1"
                    >
                      <v-btn
                        v-if="
                          getUserProfile.level.find(
                            ({ id }) => id === '1' || id === '26' || id === '30'
                          ) !== undefined
                        "
                        color="grey"
                        tile
                        dark
                        small
                        dense
                        style="font-size: 10px; width: 100px"
                        @click="fetchMatrix"
                        :loading="loading"
                      >
                        <span>Fetch Matrix</span>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-stepper-content>
      </v-stepper>

      <v-dialog v-model="commentDialog" width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Catatan Approval
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div class="vPadX0Y10">
                <v-col cols="12" class="vPad0">
                  <p
                    style="margin: 0; font-weight: bold"
                    v-if="comment != null"
                  >
                    {{ comment.note }}
                  </p>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text outlined @click="closeCommentDialog">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
  <v-card
    v-else
    class="mx-auto"
    width="100%"
    style="
      z-index: 99;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      position: fixed;
      top: 0;
      height: 100%;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.9);
    "
  >
    <v-progress-circular :size="150" :width="10" color="blue" indeterminate
      >Loading...</v-progress-circular
    >
  </v-card>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import bankJson from '../../../assets/json/bank.json'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'vendorRegistration',
  components: {},
  data() {
    return {
      config: require('../../../services/config.json')[env],
      hrsApi: buildType.apiURL('hrs'),
      upload: buildType.apiURL('upload2'),
      procApi: buildType.apiURL('proc'),
      eSanqua: buildType.apiURL('esanqua'),
      oAuthApi: buildType.apiURL('oauth'),
      build: process.env.VUE_APP_BUILD_TYPE,
      dialogForm: false,
      // permission: null,
      // appLevel: null,
      // userLevel: null,
      loading: false,
      // isLoadingPage: true,
      isDisableCompanyDropdown: false,
      isEdit: false,
      stepperElement: 1,
      wWidth: window.innerWidth,
      isAllow: false,
      rules: {
        companyNameRules: [],
        companyTypeRules: [],
        addressRules: [],
        provinceRules: [],
        postCodeRules: [],
        latRules: [],
        lngRules: [],
        phoneRules: [],
        emailRules: [],
        companyScaleRules: [],
        classificationRules: [],
        subClassificationRules: [],
        financeRules: [],
        productCategoryRules: [],
        experienceRules: [],
        documentRules: [],
        vendorNameRules: [],
        vendorPhoneRules: [],
        financeNameRules: [],
        financePhoneRules: [],
        financeAccountNumberRules: [],
        financeBankRules: [],
        financeKcuRules: [],
        financeAccountNameRules: [],
        clientNameRules: [],
        projectDescRules: [],
        projectYearRules: []
      },
      dropdown: {
        province: [],
        city: [],
        classification: [],
        subClassification: [],
        bank: bankJson,
        paymentMethod: [
          { id: 1, name: 'CASH' },
          { id: 2, name: 'TOP 15' },
          { id: 3, name: 'TOP 25' },
          { id: 4, name: 'TOP 30' },
          { id: 5, name: 'TOP 45' }
        ]
      },
      detailData: null,
      oldForm: null,
      form: {
        address: null,
        lat: null,
        lng: null,
        post_code: null,
        city: null,
        province: null,
        email: null,
        phone_number: null,
        classification: null,
        sub_classification: null,
        company_scale: null,
        business_entity: null,
        name: null,
        year_founded: null,
        account_number: null,
        contact_person: [],
        finance: [],
        product_category: [],
        experience: [],
        vendor_document: [],
        vendor_cp_name: null,
        vendor_cp_position: null,
        vendor_cp_phone: null,
        finance_pic_name: null,
        finance_pic_phone: null,
        finance_account_number: null,
        finance_bank: null,
        finance_kcu: null,
        finance_account_name: null,
        finance_payment_method: null,
        product_category_description: null,
        product_category_file: null,
        exp_client_name: null,
        exp_client_phone: null,
        exp_project_or_product: null,
        exp_year: null
      },
      comment: null,
      commentDialog: false
    }
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getVendorRegistList']),
    vendorContactPersonHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Contact Person',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jabatan',
          value: 'position',
          align: 'left',
          sortable: false
        },
        {
          text: 'No. Telepon',
          value: 'phone',
          align: 'left',
          sortable: false
        }
      ]
      if (this.isEdit) {
        arr.push({
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arr
    },
    financeHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'No. Rekening',
          value: 'account_number',
          align: 'left',
          sortable: false
        },
        {
          text: 'Bank',
          value: 'bank',
          align: 'left',
          sortable: false
        },
        {
          text: 'KCU',
          value: 'kcu',
          align: 'left',
          sortable: false
        }
      ]
      if (this.isEdit) {
        arr.push({
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arr
    },
    categoryProductHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'center',
          sortable: false
        },
        {
          text: 'File Katalog',
          value: 'file',
          align: 'center',
          sortable: false
        }
      ]
      if (this.isEdit) {
        arr.push({
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arr
    },
    experienceHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Client Name',
          value: 'client_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Client Phone',
          value: 'client_phone',
          align: 'left',
          sortable: false
        },
        {
          text: 'Proyek/Product',
          value: 'project_or_product',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tahun',
          value: 'year',
          align: 'left',
          sortable: false
        }
      ]

      if (this.isEdit) {
        arr.push({
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arr
    },
    documentHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Dokumen',
          value: 'document_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ada ?',
          value: 'is_have',
          align: 'left',
          sortable: false
        },
        {
          text: 'File',
          value: 'file',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'center',
          sortable: false
        }
      ]

      if (this.isEdit) {
        arr.push({
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arr
    },
    'dropdown.payment_method'() {
      const arr = [
        {
          id: 1,
          name: 'CASH'
        },
        {
          id: 2,
          name: 'TOP'
        }
      ]

      return arr
    },

    approvalHeaders() {
      const arrHeaders = [
        { text: 'Sequence', value: 'sequence', align: 'left', width: '5%' },
        { text: 'Doc. No', value: 'document_no', align: 'left', width: '10%' },
        { text: 'Model', value: 'table_name', align: 'center', width: '10%' },
        { text: 'User', value: 'approver_user', align: 'center', width: '20%' },
        {
          text: 'Min. Approver',
          value: 'min_approver',
          align: 'center',
          width: '5%'
        },
        {
          text: 'Approved by',
          value: 'approved',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Rejected by',
          value: 'rejected',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Created at',
          value: 'created_at',
          align: 'center',
          width: '15%'
        },
        {
          text: 'Update at',
          value: 'updated_at',
          align: 'center',
          width: '15%'
        }
      ]
      return arrHeaders
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })

    this.appLevel = this.config.application.hr.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    // this.form.company = {
    //   id: Number(this.getUserProfile.employee.company.plant_id),
    //   name: this.getUserProfile.employee.company.name
    // }
    // this.setDocument()
    this.dropdownClassification()
    this.dropdownProvince()
    this.getDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)

    // for (let i = 0; i < this.form.vendor_document.length; i++) {
    //   if (this.form.vendor_document[i].file != null) {
    //     this.clearFileUpload(i)
    //   }
    // }
  },
  watch: {
    // 'form.company'() {
    //   if (this.form != null && this.form.company != null) {
    //     // this.dropdownDepartment()
    //   }
    // },
    'form.classification'() {
      // this.form.sub_classification = null
      if (this.form != null && this.form.classification != null) {
        if (
          this.form.classification.sub_classification != null &&
          this.form.classification.sub_classification.length > 0
        ) {
          this.dropdown.subClassification =
            this.form.classification.sub_classification
        }
      } else {
        this.dropdown.subClassification = []
        this.form.sub_classification = null
      }
    },
    'form.province'() {
      if (this.form != null && this.form.province != null) {
        if (
          this.form.province.city != null &&
          this.form.province.city.length > 0
        ) {
          this.dropdown.city = this.form.province.city
        }
      } else {
        this.dropdown.city = []
        this.form.city = null
      }
    }
  },
  methods: {
    // ...mapActions(['menu_access', 'getMenuId']),

    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=2&table_name=tr_vendorregistrations`
          )
          .then((res) => {
            if (res.data.status_code !== '-99') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllow = true
              } else {
                this.isAllow = false
              }
            } else {
              this.isAllow = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    async getDetail() {
      this.loading = true
      this.detail = null
      const url = `${this.procApi}vendor/registration/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('detail>>>', res)
          if (res.data.status_code == '00') {
            // res.data.data.
            if (res.data.data.status.id == 1) {
              this.authorityCheck(res.data.data)
            }
            this.detailData = res.data.data
            console.log('this.detailData>>>', this.detailData.approver_users)
            setTimeout(() => {
              this.setDetailToForm()
            }, 300)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          return (this.loading = false)
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    saveEdit() {
      console.log('oldForm', this.oldForm)
      console.log('newForm', this.form)
      const changes = this.getChangedValues(this.oldForm, this.form)
      console.log('changes', changes)
      // if (changes.length > 0) {
      const formResult = {}

      changes.forEach((item) => {
        // Skip field dengan [0]
        if (item.field.includes('[0]')) return

        const isObject = item.tipe_data === 'object'
        const isOldNull = item.old_value === null
        const isNewNull = item.new_value === null

        // CASE 1: object → null (hapus)
        if (isObject && isNewNull && typeof item.old_value === 'object') {
          const baseKey = item.field
          const oldObj = item.old_value

          for (const subKey in oldObj) {
            const subValue = oldObj[subKey]
            if (Array.isArray(subValue)) continue

            const fullKey = `${baseKey}_${subKey}`.replace(/\./g, '_')
            formResult[fullKey] = null
          }
          return
        }

        // CASE 2: null → object (tambah)
        if (isObject && isOldNull && typeof item.new_value === 'object') {
          const baseKey = item.field
          const newObj = item.new_value

          for (const subKey in newObj) {
            const subValue = newObj[subKey]
            if (Array.isArray(subValue)) continue

            const fullKey = `${baseKey}_${subKey}`.replace(/\./g, '_')
            const finalValue =
              subKey === 'name' && typeof subValue === 'string'
                ? subValue.toUpperCase()
                : subValue

            formResult[fullKey] = finalValue
          }
          return
        }

        // CASE 3: perubahan biasa (primitive to primitive)
        const formattedKey = item.field.replace(/\./g, '_')

        const keyParts = formattedKey.split('_')
        const lastKey = keyParts[keyParts.length - 1]

        const value =
          lastKey === 'name' && typeof item.new_value === 'string'
            ? item.new_value.toUpperCase()
            : item.new_value

        formResult[formattedKey] = value
      })

      console.log('formResult', formResult)
      this.createNewForm(formResult)
      // } else {
      //   this.showMsgDialog(
      //     'warning',
      //     'Tidak ada perubahan yang disimpan',
      //     false
      //   )
      // }
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (this.isEdit) {
        this.oldForm = { ...this.form }
        this.form.vendor_cp_name = null
        this.form.vendor_cp_position = null
        this.form.vendor_cp_phone = null
        // this.form.finance.pic_name = null
        // this.form.finance.pic_phone = null
        this.form.finance.account_number = null
        this.form.finance.bank = null
        this.form.finance.kcu = null
        // this.form.finance.account_name = null
        // this.form.finance.payment_method = null
        this.form.product_category_description = null
        this.form.product_category_file = null
        this.form.exp_client_name = null
        this.form.exp_client_phone = null
        this.form.exp_project_or_product = null
        this.form.exp_year = null
      } else {
        this.oldForm = null
        this.getDetail()
      }
    },
    async clearDocument(item, index) {
      // console.log('clearDocument')
      if (this.form.vendor_document[index].file != null) {
        this.clearFileUpload(index)
      }
      setTimeout(() => {
        this.form.vendor_document[index].is_have = null
        this.form.vendor_document[index].description = null
      }, 300)
    },
    async clearFileUpload(index, method) {
      const fileName = this.form.vendor_document[index].file
      // this.form.vendor_document[index].file = null
      const data = {
        module: 'vendor_regist',
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          // console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            if (method == undefined) {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          this.form.vendor_document[index].file = null
          this.form.vendor_document[index].is_have = null
          return '-99'
        })
        .catch((err) => {
          if (method == undefined) {
            this.showMsgDialog('error', err.message, false)
            this.form.vendor_document[index].file = null
            this.form.vendor_document[index].is_have = null
          }
          return '-99'
        })
      return unlink
    },
    async uploadFileDoc(index, event) {
      let xFlag = false
      if (this.form.vendor_document[index].file == null) {
        xFlag = true
      } else {
        const xClear = await this.clearFileUpload(index, 'forward')
        console.log('xClear:', xClear)
        // if (xClear === '00') {
        xFlag = true
        // } else {
        //   this.showMsgDialog('error', 'Upload failed', false)
        // }
      }
      console.log('Index:', index)
      console.log('Event:', event)
      if (xFlag) {
        if (event !== null) {
          if (event.size <= 1024 * 1024 * 1) {
            const data = new FormData()
            data.append('file', event)
            data.append('module', 'vendor_regist')
            // data.append('module', 'vendor')
            axios
              .post(`${this.upload}esanqua/procurement`, data)
              .then((res) => {
                if (res.data.status === true) {
                  this.showMsgDialog(
                    'success',
                    'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                    false
                  )
                  this.form.vendor_document[index].file = res.data.data.name
                } else {
                  this.showMsgDialog('warning', res.data.message, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err.message, false)
              })
          } else {
            setTimeout(() => {
              this.showMsgDialog('warning', 'Max size = 1MB', false)
            }, 300)
          }
        }
        setTimeout(() => {
          console.log(this.form.vendor_document[index])
        }, 2000)
      }
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    removeTableItem(pValue, index) {
      if (pValue == 'finance') {
        return this.form[pValue].account.splice(index, 1)
      }
      if (pValue == 'product_category') {
        this.clearFileKatalog(index)
      }
      this.form[pValue].splice(index, 1)
    },
    saveVendorFinance() {
      const self = this
      // this.rules.financePaymentMethodRules = [
      //   (v) => !!v || 'Payment method is required'
      // ]
      // this.rules.financeNameRules = [
      //   (v) => !!v || 'PIC name is required'
      // ]
      // this.rules.financePhoneRules = [
      //   (v) => !!v || 'PIC phone is required'
      // ]
      this.rules.financeBankRules = [(v) => !!v || 'Bank name is required']
      this.rules.financeAccountNumberRules = [
        (v) => !!v || 'Account number is required'
      ]
      // this.rules.financeKcuRules = [
      //   (v) => !!v || 'KCU is required'
      // ]
      // this.rules.financeAccountNameRules = [
      //   (v) => !!v || 'Account name is required'
      // ]
      setTimeout(function () {
        if (self.$refs.stepTwoForm.validate()) {
          // self.form.finance.pic_name = self.form.finance_pic_name
          // self.form.finance.pic_phone = self.form.finance_pic_phone
          // self.form.finance.account_name = self.form.finance_account_name
          // self.form.finance.payment_method = self.form.finance_payment_method
          self.form.finance.account.push({
            // name: self.form.finance_pic_name,
            // phone: self.form.finance_pic_phone,
            account_number: self.form.finance.account_number,
            bank: self.form.finance.bank,
            kcu: self.form.finance.kcu
            // account_name: self.form.finance_account_name,
            // payment_method: self.form.finance_payment_method
          })
          setTimeout(() => {
            // self.form.finance.pic_name = null
            // self.form.finance.pic_phone = null
            self.form.finance.account_number = null
            self.form.finance.bank = null
            self.form.finance.kcu = null
            // self.form.finance.account_name = null
            // self.form.finance.payment_method = null
            self.rules.financeBankRules = []
            self.rules.financeAccountNumberRules = []
            // self.rules.financeAccountNameRules = []
          }, 100)
        }
      })
    },
    saveContactPerson() {
      const self = this
      this.rules.vendorNameRules = [
        (v) => !!v || 'Contact person name is required'
      ]
      this.rules.vendorPhoneRules = [
        (v) => !!v || 'Contact person phone is required'
      ]
      setTimeout(function () {
        if (self.$refs.stepOneForm.validate()) {
          self.form.contact_person.push({
            name: self.form.vendor_cp_name,
            phone: self.form.vendor_cp_phone,
            position: self.form.vendor_cp_position
          })
          setTimeout(() => {
            self.form.vendor_cp_name = null
            self.form.vendor_cp_phone = null
            self.form.vendor_cp_position = null
            self.rules.vendorNameRules = []
            self.rules.vendorPhoneRules = []
          }, 100)
        }
      })
    },
    saveProductCategory() {
      const self = this
      this.rules.productCategoryRules = [
        (v) => !!v || 'Product category is required'
      ]
      setTimeout(function () {
        if (self.$refs.stepThreeForm.validate()) {
          self.form.product_category.push({
            description: self.form.product_category_description,
            file: self.form.product_category_file
          })
          setTimeout(() => {
            self.form.product_category_description = null
            self.form.product_category_file = null
            self.rules.productCategoryRules = []
          }, 100)
        }
      })
    },
    saveExperience() {
      const self = this
      this.rules.clientNameRules = [(v) => !!v || 'Client name is required']
      this.rules.projectDescRules = [
        (v) => !!v || 'Supplied project & product is required'
      ]
      this.rules.projectYearRules = [(v) => !!v || 'Project year is required']
      setTimeout(function () {
        if (self.$refs.stepFourForm.validate()) {
          self.form.experience.push({
            client_name: self.form.exp_client_name,
            client_phone: self.form.exp_client_phone,
            project_or_product: self.form.exp_project_or_product,
            year: self.form.exp_year
          })
          setTimeout(() => {
            self.form.exp_client_name = null
            self.form.exp_client_phone = null
            self.form.exp_project_or_product = null
            self.form.exp_year = null
            self.rules.clientNameRules = []
            self.rules.projectDescRules = []
            self.rules.projectYearRules = []
          }, 100)
        }
      })
    },
    nextStep(val) {
      const self = this
      if (val === 1) {
        this.rules.companyNameRules = [(v) => !!v || 'Company name is required']
        this.rules.companyTypeRules = [(v) => !!v || 'Company type is required']
        this.rules.addressRules = [(v) => !!v || 'Address is required']
        this.rules.provinceRules = [(v) => !!v || 'Province is required']
        this.rules.cityRules = [(v) => !!v || 'City is required']
        // // this.rules.postCodeRules = [(v) => !!v || 'Post code is required']
        this.rules.addressRules = [(v) => !!v || 'Address is required']
        // // this.rules.latRules = [(v) => !!v || 'Lat is required']
        // // this.rules.lngRules = [(v) => !!v || 'Lng is required']
        this.rules.phoneRules = [(v) => !!v || 'Company phone is required']
        this.rules.emailRules = [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ]
        // // this.rules.websiteRules = [(v) => !!v || 'Website is required']
        this.rules.companyScaleRules = [
          (v) => !!v || 'Company scale is required'
        ]
        this.rules.classificationRules = [
          (v) => !!v || 'Classification is required'
        ]
        // // this.rules.subClassificationRules = [(v) => !!v || 'Company scale is required']
        this.rules.vendorNameRules = []
        this.rules.vendorPhoneRules = []
        if (this.form.contact_person.length < 1) {
          return this.showMsgDialog(
            'warning',
            'Contact person wajib diisi minimal 1',
            false
          )
        }
        setTimeout(function () {
          if (self.$refs.stepOneForm.validate()) {
            self.stepperElement = 2
          }
        })
      }

      if (val === 2) {
        if (this.form.finance.account.length < 1) {
          return this.showMsgDialog(
            'warning',
            'Data finance wajib diisi minimal 1',
            false
          )
        }

        this.rules.financeNameRules = [
          (v) => !!v || 'Finance PIC Name is required'
        ]
        this.rules.financeAccountNameRules = [
          (v) => !!v || 'Finance Account Name is required'
        ]
        this.rules.financePhoneRules = [
          (v) => !!v || 'Finance PIC Phone is required'
        ]
        setTimeout(function () {
          if (self.$refs.stepTwoForm.validate()) {
            self.stepperElement = 3
          }
        })
      }

      if (val === 3) {
        setTimeout(function () {
          self.stepperElement = 4
        })
      }
      if (val === 4) {
        setTimeout(function () {
          self.stepperElement = 5
        })
      }
    },
    createNewForm(form) {
      const vendorDocument = this.form.vendor_document.map((doc) => ({
        document_name: doc.document_name,
        is_have: doc.is_have,
        file: doc.file,
        description: doc.description
      }))

      const newForm = {
        act: 'update',
        id: this.$route.params.id,
        vendor_contact: this.form.contact_person,
        vendor_finance: this.form.finance,
        vendor_experience: this.form.experience,
        vendor_product_category: this.form.product_category,
        vendor_document: vendorDocument
      }
      // gabungkan form dengan newForm
      Object.assign(newForm, form)
      console.log('save>>>', newForm)
      this.saveChange(newForm)
    },
    async saveChange(form) {
      this.loading = true
      await axios
        .post(`${this.procApi}vendor/registration/save`, form)
        .then((res) => {
          console.log(res.data)
          this.loading = false
          if (res.data.status_code == '00') {
            this.isEdit = false
            this.showMsgDialog('success', res.data.status_msg, false)
            setTimeout(() => {
              this.getDetail()
            }, 300)
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    closeForm() {
      for (let i = 0; i < this.form.vendor_document.length; i++) {
        if (this.form.vendor_document[i].file != null) {
          this.clearFileUpload(i)
        }
      }
      setTimeout(() => {
        this.$refs.stepOneForm.reset()
        this.$refs.stepTwoForm.reset()
        this.$refs.stepThreeForm.reset()
        this.$refs.stepFourForm.reset()
        this.$refs.stepFiveForm.reset()
        setTimeout(() => {
          this.$router.push('/e-catalogue/vendor-registration')
          // this.dialogForm = false
        }, 100)
      }, 100)
    },
    async dropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async dropdownClassification() {
      await axios
        .get(
          `${this.procApi}master/classification/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.classification = res.data.data)
          }
          return (this.dropdown.classification = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.classification = [])
        })
    },
    async dropdownProvince() {
      await axios
        .get(
          `${this.procApi}master/province/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.province = res.data.data)
          }
          return (this.dropdown.province = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.province = [])
        })
    },
    async dropdownCity() {
      await axios
        .get(
          `${this.procApi}master/city/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.city = res.data.data)
          }
          return (this.dropdown.city = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.city = [])
        })
    },
    nextPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) + 1
        const path = `/e-catalogue/vendor-registration/detail/${this.getVendorRegistList.registrationList[pageIndex].id}?idx=${pageIndex}`
        if (this.$route.path !== path) this.$router.push(path)
        setTimeout(() => {
          this.getDetail()
        }, 200)
      } catch (e) {
        this.loading = false
      }
    },
    previousPage() {
      this.loading = true
      try {
        const pageIndex = Number(this.$route.query.idx) - 1
        const path = `/e-catalogue/vendor-registration/detail/${this.getVendorRegistList.registrationList[pageIndex].id}?idx=${pageIndex}`
        if (this.$route.path !== path) this.$router.push(path)
        setTimeout(() => {
          this.getDetail()
        }, 200)
      } catch (e) {
        this.loading = false
      }
    },
    setDetailToForm() {
      const xData = { ...this.detailData }
      // this.form = {}
      if (xData.vendor_document != null) {
        this.form.vendor_document = xData.vendor_document
      }
      if (xData.vendor_product_category != null) {
        this.form.product_category = xData.vendor_product_category
      }
      if (xData.vendor_experience != null) {
        this.form.experience = xData.vendor_experience
      }
      if (xData.vendor_finance != null) {
        this.form.finance = xData.vendor_finance
      }
      if (xData.vendor_contact != null) {
        this.form.contact_person = xData.vendor_contact
      }
      if (xData.province != null) {
        this.form.province = xData.province
        this.form.province.city = [xData.city]
        this.form.city = xData.city
        this.dropdown.city = [xData.city]
      }
      if (xData.classification != null) {
        this.form.classification = xData.classification
        this.form.classification.sub_classification = [xData.sub_classification]
        this.form.sub_classification = xData.sub_classification
        this.dropdown.subClassification = [xData.sub_classification]
      }
      this.form.request_no = xData.request_no
      this.form.address = xData.address
      this.form.lat = xData.lat
      this.form.lng = xData.lng
      this.form.post_code = xData.post_code
      this.form.email = xData.email
      this.form.phone_number = xData.phone_number
      this.form.company_scale = xData.company_scale
      this.form.business_entity = xData.business_entity
      this.form.name = xData.name
      this.form.year_founded = xData.year_founded
      this.form.website = xData.website
      this.form.status = xData.status
      this.form.createdAt = xData.createdAt
      this.form.created_by_name = xData.created_by_name
      this.form.takeAt = xData.takeAt
      this.form.take_by_name = xData.take_by_name
    },
    downloadFile(xItem) {
      console.log('download>>>', xItem)
      window.open(xItem.path + xItem.file, '_blank')
    },
    convertDate(raw) {
      let res = '-'
      if (raw != null && raw != undefined && raw != '' && raw != 0) {
        // res = new Date().toLocaleDateString()
        const date = new Date(raw)
        const local = date.toLocaleDateString('id')
        const split = local.split('/')
        const day = split[0].length == 1 ? '0' + split[0] : split[0]
        const month = split[1].length == 1 ? '0' + split[1] : split[1]
        const year = split[2]
        res = `${day}-${month}-${year}`
      }
      return res
    },
    statusColor(val) {
      switch (val) {
        case 0:
          return 'color: #black; background-color: #4e4e4e1f;'
        case 1:
          return 'color: rgb(138, 90, 0); background-color: rgba(255, 166, 0, 0.3);'
        case 2:
          return 'color: green; background-color: #4e4e4e1f;'
        case 3:
          return 'color: green; background-color: #4e4e4e1f;'
        case 4:
          return 'color: red; background-color: #4e4e4e1f;'
        case 5:
          return 'color: red; background-color: #4e4e4e1f;'
        default:
          return 'black'
      }
    },
    submitDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            approval_matrix_id:
              this.detailData.approval_matrix != null &&
              this.detailData.approval_matrix.lenght > 0
                ? this.detailData.approval_matrix[0].id
                : null
          }
          axios
            .post(`${this.procApi}vendor/registration/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },

    confirmDocument() {
      this.showMsgDialog2(
        'question',
        'Setujui pengajuan ini sekarang ?',
        true
        // inputType,
        // inputAtt
      ).then((res) => {
        if (res.isConfirmed) {
          const document_id = this.$route.params.id
          this.loading = true
          axios
            .post(`${this.procApi}vendor/registration/confirm`, {
              document_id: document_id,
              note: res.value
            })
            .then((res) => {
              this.showMsgDialog('success', res.data.status_msg, false)
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    rejectDocument() {
      this.showMsgDialog2(
        'question',
        'Jangan setujui pengajuan ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.loading = true

          const date = new Date()
          const local = date.toLocaleString('id')
          const updateAt = `[${local}]\n${res.value}`
          axios
            .post(`${this.procApi}vendor/registration/reject`, {
              document_id: this.$route.params.id,
              reject_reason: updateAt
            })
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
              this.loading = false
              this.getDetail()
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    // takeDocument() {
    //   this.showMsgDialog(
    //     'question',
    //     'Anda yakin ingin memproses dokumen ini ?',
    //     true
    //   ).then(async (res) => {
    //     if (res.isConfirmed) {
    //       this.loading = true
    //       const form = {
    //         id: this.$route.params.id
    //       }
    //       axios
    //         .post(`${this.procApi}vendor/registration/take`, form)
    //         .then(async (res) => {
    //           this.loading = false
    //           if (res.data.status_code == '00') {
    //             this.showMsgDialog('success', res.data.status_msg, false)
    //             this.getDetail()
    //           } else {
    //             this.showMsgDialog('warning', res.data.status_msg, false)
    //           }
    //         })
    //         .catch((err) => {
    //           this.showMsgDialog('error', err, false)
    //           this.loading = false
    //         })
    //     }
    //   })
    // },
    cancelDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            cancel_reason: res.value
          }
          axios
            .post(`${this.procApi}vendor/registration/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    doneDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin memproses pengajuan ini ?',
        true,
        undefined,
        'text',
        'Masukkan kode vendornya'
      ).then(async (res) => {
        if (res.isConfirmed) {
          console.log(res)
          if (res.value == null || res.value == '') {
            return this.showMsgDialog(
              'warning',
              'Kode vendor harus diisi',
              false
            )
          }
          this.loading = true
          const form = {
            id: this.$route.params.id,
            code: res.value
          }
          axios
            .post(`${this.procApi}vendor/registration/done`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin menggunakan dokumen ini kembali?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
          }
          axios
            .post(`${this.procApi}vendor/registration/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },

    openCommentDialog(obj) {
      console.log(obj)
      this.comment = obj
      setTimeout(() => {
        this.commentDialog = true
      }, 100)
    },
    closeCommentDialog() {
      this.commentDialog = false
      setTimeout(() => {
        this.comment = null
      }, 100)
    },
    showMsgDialog2(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pText,
      inputType,
      inputLabel
    ) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: inputType == undefined ? 'textarea' : inputType,
            inputLabel:
              inputLabel == undefined
                ? 'Tolong isi keterangan pada kolom dibawah sebelum submit'
                : inputLabel,
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    getChangedValues(oldObj, newObj, path = '') {
      const changes = []

      // Gabungkan semua key dari old dan new
      const allKeys = new Set([
        ...Object.keys(oldObj || {}),
        ...Object.keys(newObj || {})
      ])

      for (const key of allKeys) {
        const fullPath = path ? `${path}.${key}` : key

        const oldVal = oldObj ? oldObj[key] : undefined
        const newVal = newObj ? newObj[key] : undefined

        const oldType = typeof oldVal
        const newType = typeof newVal

        if (Array.isArray(newVal) && Array.isArray(oldVal)) {
          // Compare arrays by index
          newVal.forEach((item, index) => {
            const oldItem = oldVal[index] || {}
            changes.push(
              ...this.getChangedValues(oldItem, item, `${fullPath}[${index}]`)
            )
          })
        } else if (
          newType === 'object' &&
          newVal !== null &&
          oldType === 'object' &&
          oldVal !== null
        ) {
          // Both are objects: recurse
          changes.push(...this.getChangedValues(oldVal, newVal, fullPath))
        } else {
          // If either value is primitive or null, compare directly
          const isChanged = oldVal !== newVal
          const isOldDefined = oldVal !== undefined

          if (isChanged && isOldDefined) {
            changes.push({
              field: fullPath,
              old_value: oldVal,
              new_value: newVal,
              // eslint-disable-next-line
              tipe_data: Array.isArray(oldVal)
                ? 'array'
                : oldVal === null
                ? typeof newVal // eslint-disable-line indent
                : typeof oldVal // eslint-disable-line indent
            })
          }
        }
      }

      return changes
    },
    async clearFileKatalog(index, method) {
      let fileName = null
      if (index == undefined) {
        fileName = this.form.product_category_file
        console.log('Ga ada data yang dipassing')
      } else {
        fileName = this.form.product_category[index].file
      }
      // this.form.vendor_document[index].file = null
      const data = {
        module: 'vendor_regist',
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          // console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            if (method == undefined) {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          if (index != undefined) {
            this.form.product_category[index].file = null
          }
          return '-99'
        })
        .catch((err) => {
          if (method == undefined) {
            this.showMsgDialog('error', err.message, false)
            if (index != undefined) {
              this.form.product_category[index].file = null
            }
          }
          return '-99'
        })
      return unlink
    },
    async uploadKatalog(event) {
      // const xFlag = false
      console.log('Event:', event)
      // if (xFlag) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 1) {
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'vendor_regist')
          // data.append('module', 'vendor')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.form.product_category_file = res.data.data.name
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 1MB', false)
          }, 300)
        }
      }
      // setTimeout(() => {
      //   console.log(this.form.product_category[index])
      // }, 2000)
      // }
    },

    async fetchMatrix() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            approval_matrix_id:
              this.detailData.approval_matrix != null &&
              this.detailData.approval_matrix.lenght > 0
                ? this.detailData.approval_matrix[0].id
                : null
          }
          await axios
            .post(`${this.procApi}vendor/registration/fetch_matrix`, form)
            .then(async (res) => {
              if (res.data.status_code == '00') {
                if (res.data.approval_matrix_result.status_code == '00') {
                  this.getDetail()
                } else {
                  this.showMsgDialog(
                    'warning',
                    res.data.approval_matrix_result.status_msg,
                    false
                  )
                }
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
              this.loading = false
              this.showMsgDialog(
                res.data.status_code == '00' ? 'success' : 'warning',
                res.data.status_msg,
                false
              )
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
